// Decides whether the Home canvas plays its login entrance (widget stagger +
// KPI count-up). One play per login: the sessionStorage stamp survives
// navigation but is CLEARED on logout (useAuth) so a re-login replays. The
// per-pageload latch keeps every widget in one render pass agreeing.
const KEY = 'mrpcomp:home-entered';
let play: boolean | null = null;

export function homeEntranceActive(): boolean {
  if (play == null) {
    try {
      const done = sessionStorage.getItem(KEY) === '1';
      if (!done) sessionStorage.setItem(KEY, '1');
      play = !done;
    } catch { play = false; }
  }
  return play;
}

// Consume: the entrance has visibly played — later Home mounts in this same
// page load must NOT replay it (clicking the Home tab used to re-animate
// because the per-pageload cache stayed true forever).
export function markHomeEntrancePlayed() {
  play = false;
}

// Re-arm: next Home mount plays again (called on logout).
export function resetHomeEntrance() {
  play = null;
  try { sessionStorage.removeItem(KEY); } catch { /* ignore */ }
}
